var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.open
    ? _c(
        "Modal",
        {
          attrs: {
            title: _vm.$tAnnotDisplayName(_vm.annotation),
            confirmMessage: _vm.$t("partOfSpeech.submit"),
            lg: "",
            close: false,
          },
          on: {
            confirm: function ($event) {
              _vm.submit()
              _vm.$emit("close")
            },
          },
          scopedSlots: _vm._u(
            [
              {
                key: "footer",
                fn: function () {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button" },
                        on: { click: _vm.reset },
                      },
                      [_vm._v(_vm._s(_vm.$t("partOfSpeech.reset")))]
                    ),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            false,
            2929870332
          ),
        },
        [
          _vm.isValidTagset
            ? [
                _c("div", { staticClass: "list-group-container" }, [
                  _c(
                    "div",
                    { staticClass: "list-group main" },
                    _vm._l(_vm.tagset.values, function (value) {
                      return _c(
                        "button",
                        {
                          key: value.value,
                          class: {
                            "list-group-item": true,
                            active: _vm.annotationValue === value,
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.annotationValue =
                                _vm.annotationValue === value ? null : value
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" + _vm._s(value.displayName) + " "
                          ),
                          _c("Debug", [
                            _vm._v("(" + _vm._s(value.value) + ")"),
                          ]),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.annotationValue
                    ? _c(
                        "div",
                        { staticClass: "category-container" },
                        [
                          _vm._l(
                            _vm.annotationValue.subAnnotationIds,
                            function (subId) {
                              return _c(
                                "ul",
                                { staticClass: "list-group category" },
                                [
                                  _c(
                                    "li",
                                    {
                                      staticClass:
                                        "list-group-item active category-name",
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$tAnnotDisplayName(
                                              _vm.allAnnotations[subId]
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                      _c("Debug", [
                                        _vm._v("(" + _vm._s(subId) + ")"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.tagset.subAnnotations[subId].values,
                                    function (subValue) {
                                      return !subValue.pos ||
                                        subValue.pos.includes(
                                          _vm.annotationValue.value
                                        )
                                        ? _c(
                                            "li",
                                            {
                                              key: subValue.value,
                                              staticClass:
                                                "list-group-item category-value",
                                            },
                                            [
                                              _c(
                                                "label",
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.selected[
                                                            `${_vm.annotationValue.value}/${subId}/${subValue.value}`
                                                          ],
                                                        expression:
                                                          "selected[`${annotationValue.value}/${subId}/${subValue.value}`]",
                                                      },
                                                    ],
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.selected[
                                                          `${_vm.annotationValue.value}/${subId}/${subValue.value}`
                                                        ]
                                                      )
                                                        ? _vm._i(
                                                            _vm.selected[
                                                              `${_vm.annotationValue.value}/${subId}/${subValue.value}`
                                                            ],
                                                            null
                                                          ) > -1
                                                        : _vm.selected[
                                                            `${_vm.annotationValue.value}/${subId}/${subValue.value}`
                                                          ],
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a =
                                                            _vm.selected[
                                                              `${_vm.annotationValue.value}/${subId}/${subValue.value}`
                                                            ],
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.selected,
                                                                `${_vm.annotationValue.value}/${subId}/${subValue.value}`,
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.selected,
                                                                `${_vm.annotationValue.value}/${subId}/${subValue.value}`,
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.selected,
                                                            `${_vm.annotationValue.value}/${subId}/${subValue.value}`,
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        subValue.displayName
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t"
                                                  ),
                                                  _c("Debug", [
                                                    _vm._v(
                                                      "(" +
                                                        _vm._s(subValue.value) +
                                                        ")"
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e()
                                    }
                                  ),
                                ],
                                2
                              )
                            }
                          ),
                          _vm._v(" "),
                          _vm.annotationValue.subAnnotationIds.length === 0
                            ? _c("em", [
                                _vm._v(
                                  _vm._s(_vm.$t("partOfSpeech.noOptions"))
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.query
                  ? [
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.query))]),
                    ]
                  : _vm._e(),
              ]
            : _c("div", { staticClass: "alert alert-danger" }, [
                _vm._v("\n\t\t" + _vm._s(_vm.errorMessage) + "\n\t"),
              ]),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }